import connectHttpBase from '@/lib/connect-client/connect-http-base'
import Toast from '@/lib/toast'
import axios from 'axios'
import ApplicationConfig from '@/lib/application-config'
import i18n from '@/lib/i18n'
import * as Constants from '@/lib/constants'

export default class Serverless {
  static async getFilterList(myUserName) {
    const key = connectHttpBase.calclateSecretHash(myUserName)
    const endpoint = ApplicationConfig.getTaskFilterServer() + myUserName + '?key=' + key
    return axios
      .get(endpoint)
      .then(res => {
        const ret = JSON.stringify(res.data)
        return res.data.Items
      })
      .catch(err => {
        Toast.error(i18n.tt('customTaskFilterGetError'))
        return ''
      })
  }
  static async putFilterItem(myUserName, modify) {
    const endpoint = ApplicationConfig.getTaskFilterServer() + myUserName

    return axios
      .put(endpoint, modify)
      .then(res => {
        return true
      })
      .catch(err => {
        Toast.error(i18n.tt('customTaskFilterPutError'))
        return false
      })
  }
  static async postFilterItem(myUserName, modify) {
    const endpoint = ApplicationConfig.getTaskFilterServer() + myUserName

    return axios
      .post(endpoint, modify)
      .then(res => {
        return true
      })
      .catch(err => {
        Toast.error(i18n.tt('customTaskFilterPostError'))
        return false
      })
  }
  static async putDefaultFlg(modify) {
    const endpoint = ApplicationConfig.getTaskFilterServer() + Constants.TASK_FILTER_DEFAULT_FLG_ENDPOINT

    return axios
      .put(endpoint, modify)
      .then(res => {
        return true
      })
      .catch(err => {
        return false
      })
  }
  static async deleteFilterItem(myUserName, uuid) {
    const key = connectHttpBase.calclateSecretHash(myUserName)
    const endpoint = ApplicationConfig.getTaskFilterServer() + myUserName

    return axios
      .delete(endpoint, { data: { uuid: uuid, key: key } })
      .then(res => {
        return true
      })
      .catch(err => {
        Toast.error(i18n.tt('customTaskFilterDeleteError'))
        return false
      })
  }
}
